import React, { useState } from "react"

type FontPickerProps = {
  fonts: { name: string; fontFamily: string; label: string }[]
  selectedFont: { name: string; fontFamily: string; label: string }
  setFont: (font: any) => void
}

export const FontPicker: React.FC<FontPickerProps> = ({
  fonts,
  selectedFont,
  setFont,
}) => {
  return (
    <div style={{ display: "flex", gap: "10px" }}>
      {fonts.slice(0, 10).map((font, idx) => (
        <span
          key={idx}
          style={{
            border: "1px solid",
            minHeight: "28px",
            padding: "8px",
            fontFamily: font.fontFamily,
            borderRadius: "10px",
            fontSize: "14px",
            color:
              selectedFont?.fontFamily === font.fontFamily ? "#000" : "#6a6a6a", // Selected font in black, others in light gray
            // fontWeight: selectedFont === font.fontFamily ? "700" : "500", // Bold for selected
            cursor: "pointer",
            borderColor:
              selectedFont?.fontFamily === font.fontFamily
                ? "#245192"
                : "#cecccc",
            // fontFamily: selectedFont,

            // backgroundColor:
            //   selectedFont === font.fontFamily ? "#F0F0F0" : "transparent",
          }}
          onClick={() => setFont(font)}
        >
          {font.label}
        </span>
      ))}
    </div>
  )
}
